"use client";

import { useAdmin } from "@/lib/admin/context";
import { Icon } from "@/lib/icons/Icon";
import styles from "./DevBannerToggle.module.css";

/**
 * DevBannerToggle — przycisk pokazujący/ukrywający banner developera
 * (`<AlignmentChecker>`).
 *
 * **Widoczny TYLKO w trybie dev** (`NODE_ENV === 'development'`) — spójne
 * z widocznością samego banneru.
 *
 * Stan persistowany w `localStorage` przez `AdminContext.devBannerHidden`.
 * Przeładowanie strony zachowuje preferencję admina.
 */
export function DevBannerToggle() {
  const { devBannerHidden, setDevBannerHidden, t } = useAdmin();

  if (process.env.NODE_ENV !== "development") return null;

  const handleClick = () => setDevBannerHidden(!devBannerHidden);

  return (
    <button
      type="button"
      className={styles.btn}
      data-active={devBannerHidden ? "hidden" : "shown"}
      onClick={handleClick}
      title={
        devBannerHidden
          ? t.topBar.devBannerToggle.titleHidden
          : t.topBar.devBannerToggle.titleShown
      }
      aria-label={
        devBannerHidden
          ? t.topBar.devBannerToggle.ariaHidden
          : t.topBar.devBannerToggle.ariaShown
      }
    >
      <Icon name="gear" />
    </button>
  );
}
